export default "__VITE_ASSET__ebsmlM$T__"